(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ts-compat-check"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Palabra normalizada: sin acentos, en mayúsculas, solo letras y números. */
    function norm(s) {
      return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .toUpperCase().replace(/[^A-Z0-9]/g, '');
    }
    function words(s) {
      return (s || '').split(/[\s,;·|()\[\]:]+/).map(norm).filter(Boolean);
    }
    function isCode(w) { return /[0-9]/.test(w) && w.length >= 5; }
    /* Quita los comentarios que el editor de temas añade alrededor de los textos. */
    function clean(s) {
      return (s || '').replace(/<!--[\s\S]*?-->/g, '').trim();
    }

    var LABEL = /(modelos?\s+compatibles?|compatibilidad(es)?|compatible\s+con|modelos?\s+compat[ií]ve(l|is)|compatibilidades?)/i;
    var HEADING = /^(H1|H2|H3|H4|H5|H6)$/;

    /* Devuelve las entradas (un modelo por entrada) de la lista de compatibles. */
    function collectEntries(root) {
      var out = [];
      function add(text) {
        (text || '').split(/\s+\/\s+|\n/).forEach(function (t) {
          t = t.replace(/\s+/g, ' ').trim();
          if (t && t.length <= 80 && !/^ver\s+m[aá]s/i.test(t)) out.push(t);
        });
      }
      function addFrom(el) {
        var items = el.matches('li, td, a') ? [el] : el.querySelectorAll('li, td, a');
        var n = 0;
        items.forEach(function (it) {
          /* Evita contar dos veces un enlace dentro de un <li> o <td>. */
          if (it.tagName === 'A' && it.closest('li, td')) return;
          add(it.textContent); n++;
        });
        return n;
      }

      /* 1. Metacampo de compatibilidades, si está configurado en el bloque. */
      var tpl = root.querySelector('template[data-ts-models]');
      if (tpl) {
        var box = document.createElement('textarea');
        box.innerHTML = clean(tpl.innerHTML);
        add(box.value);
      }

      /* 2. Zona indicada a mano en el bloque (selector distinto de "main"). */
      var sel = (root.dataset.scope || 'main').trim();
      var scope = null;
      try { scope = document.querySelector(sel); } catch (e) {}
      scope = scope || document.querySelector('main') || document.body;
      if (sel !== 'main' && sel !== 'body' && scope) addFrom(scope);

      /* 3. Detección automática: busca los rótulos "Modelos compatibles" o
            "Compatibilidades" y lee la lista que va justo después. */
      var labels = scope.querySelectorAll('h2,h3,h4,h5,h6,summary,strong,b,dt,th,p,span,div');
      labels.forEach(function (lab) {
        if (lab.closest('[data-ts-compat]')) return;
        var own = '';
        lab.childNodes.forEach(function (c) { if (c.nodeType === 3) own += c.nodeValue; });
        own = own.trim();
        var txt = own || (lab.children.length <= 1 ? lab.textContent.trim() : '');
        if (!txt || txt.length > 80 || !LABEL.test(txt)) return;
        var node = lab;
        for (var up = 0; up < 4 && node && node !== scope; up++) {
          var found = 0;
          var sib = node.nextElementSibling;
          for (var i = 0; sib && i < 30; i++, sib = sib.nextElementSibling) {
            if (HEADING.test(sib.tagName)) break;
            if (sib.closest('[data-ts-compat]')) continue;
            found += addFrom(sib);
          }
          if (found) break;
          node = node.parentElement;
        }
      });

      /* Quita repetidos. */
      var seen = {};
      return out.filter(function (t) {
        var k = norm(t);
        if (!k || seen[k]) return false;
        seen[k] = 1; return true;
      });
    }

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      var form = root.querySelector('form');
      var input = root.querySelector('.ts-compat__input');
      var box = root.querySelector('[data-result]');
      var msg = root.querySelector('[data-msg]');
      var contact = root.querySelector('[data-contact]');
      var index = null;

      /* Se lee la ficha una sola vez, y solo si el cliente usa el comprobador. */
      function getIndex() {
        if (index !== null) return index;
        var titleWords = {};
        words(root.dataset.title).forEach(function (w) { titleWords[w] = 1; });
        index = {
          titleWords: titleWords,
          entries: collectEntries(root).map(function (label) {
            return { label: label, w: words(label), joined: norm(label) };
          })
        };
        return index;
      }

      function show(state, model, extra) {
        var text = clean(root.getAttribute('data-msg-' + state));
        msg.textContent = text.replace('[modelo]', model).replace('[ejemplos]', extra || '');
        box.dataset.state = state;
        box.hidden = false;
        if (contact) contact.hidden = !(state === 'no' || state === 'partial' || state === 'empty');
      }

      /* Posición en la que las palabras q aparecen seguidas dentro de w, o -1. */
      function phraseAt(w, q) {
        for (var i = 0; i + q.length <= w.length; i++) {
          var ok = true;
          for (var j = 0; j < q.length; j++) { if (w[i + j] !== q[j]) { ok = false; break; } }
          if (ok) return i;
        }
        return -1;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var typed = input.value.replace(/\s+/g, ' ').trim();
        var shown = typed;
        var qj = norm(typed);
        if (qj.length < 3 || (/^[0-9]+$/.test(qj) && qj.length < 4)) return show('short', shown);

        var idx = getIndex();
        if (!idx.entries.length) return show('empty', shown);

        /* Las palabras de marca o del título ("Krups", "Dolce Gusto") no cuentan
           si el cliente ha escrito algo más: "Krups Piccolo" se busca como "Piccolo". */
        var qAll = words(typed);
        var q = qAll.filter(function (w) { return !idx.titleWords[w]; });
        if (!q.length) q = qAll;
        var qCore = q.join('');

        /* 1. Es la referencia de la propia pieza. */
        if (/[0-9]/.test(qj) && qj.length >= 5) {
          var refs = words(root.dataset.refs).concat(words(root.dataset.title).filter(isCode));
          if (refs.indexOf(qj) !== -1) return show('ref', shown);
        }

        var yes = false;
        var near = [];
        idx.entries.forEach(function (en) {
          if (yes) return;
          /* a) Código escrito con otros separadores: "MSM 5007-01" = "MSM5007/01". */
          if (en.joined === qj || en.joined === qCore) { yes = true; return; }
          for (var i = 0; i < en.w.length; i++) {
            if (isCode(qj) && (en.w[i] === qj || (en.w[i] + (en.w[i + 1] || '')) === qj)) { yes = true; return; }
          }
          /* b) Las palabras escritas aparecen seguidas en la entrada, y lo que
                sobra de la entrada es solo marca: "Piccolo" = "Dolce Gusto Piccolo",
                pero "Piccolo" no confirma "Piccolo XS". */
          var at = phraseAt(en.w, q);
          if (at !== -1) {
            var rest = en.w.filter(function (w, k) { return k < at || k >= at + q.length; });
            var onlyBrand = rest.every(function (w) { return idx.titleWords[w]; });
            if (onlyBrand || q.some(isCode)) { yes = true; return; }
            near.push(en.label);
            return;
          }
          /* c) Parecidos: empieza igual (código incompleto) o comparte la primera palabra. */
          var starts = en.w.some(function (w) { return qCore.length >= 4 && w.indexOf(qCore) === 0; });
          var shares = q[0].length >= 3 && en.w.indexOf(q[0]) !== -1 && !/^[0-9]+$/.test(q[0]);
          if (starts || shares) near.push(en.label);
        });

        if (yes) return show('yes', shown);
        if (near.length) return show('partial', shown, near.slice(0, 5).join(', '));
        show('no', shown);
      });
    }

    function boot() {
      document.querySelectorAll('[data-ts-compat]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
